<template>
  <div class="animated fadeIn">
    <b-row class="mt-4">
      <b-col md="2">
        <ProductImageThumbnail
          :product_object="this.current_orderitem.ProductOrdered"
        />
      </b-col>
      <b-col md="6"
        ><h4 class="actionable">
          {{ current_orderitem.ProductOrdered.ProductName }}
        </h4>
        <h6>{{ current_orderitem.ProductOrdered.ProductShortDesc }}</h6>
      </b-col>
      <b-col md="2"
        ><h5>
          {{ current_orderitem.Quantity }}
        </h5></b-col
      >
      <b-col md="2"
        ><h5>{{ OrderItemSubtotal }} points</h5></b-col
      >
    </b-row>
    <hr />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProductImageThumbnail from "@/components/CustomSubComponents/ProductImageThumbnail.vue";
export default {
  name: "OrderItemRow",
  components: { ProductImageThumbnail },
  props: {
    orderitem_object: { type: Object }
  },
  data() {
    return {
      current_orderitem: this.orderitem_object,
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
      activeColor2: {},
      timer: null
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },
    saveField: function(event) {
      //   var _operation = {
      //     TerritoryID: this.current_territory.TerritoryID,
      //     RotationID: this.current_rotation.RotationID,
      //     FieldToSet: event.target.id,
      //     ValueToSet: event.target.value,
      //   };
      //   this.$store
      //     .dispatch("territory/SaveRotation", _operation)
      //     .then();
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  computed: {
    ...mapState(["order", "global", "n_user"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    OrderItemSubtotal() {
      return (
        this.current_orderitem.Quantity * this.current_orderitem.PriceFrozen
      );
    }
  },
  created() {},
  watch: {},
  mounted() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
